import React, {FC} from "react";
import {AcComplexTransaction} from "../../components";
import {PageEnum} from "../../models";

export const JournalVoucherPage: FC = () => {
    return <AcComplexTransaction formId={PageEnum.JournalVoucher}/>;
};
